import { render, staticRenderFns } from "./Forum.vue?vue&type=template&id=43e5bd99&scoped=true"
import script from "./Forum.vue?vue&type=script&lang=js"
export * from "./Forum.vue?vue&type=script&lang=js"
import style0 from "./Forum.vue?vue&type=style&index=0&id=43e5bd99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e5bd99",
  null
  
)

export default component.exports